module.exports = __webpack_public_path__ + "img/adv_isolate.4b9f65dd.png";